// CSR-2336 — a policy substatus qualifies the main status without replacing it:
// a Geico NONRENEWED term is Active (or Expired, by its dates) with substatus
// "non-renewal". COI eligibility and in-force counts read the main status only.
// The Data Center owns the field (CSR-2350).

// Mirrors the DC `substatus` column's allowed values.
export const POLICY_SUBSTATUSES = ["non-renewal"] as const;
export type PolicySubstatus = (typeof POLICY_SUBSTATUSES)[number];

export function isPolicySubstatus(value: unknown): value is PolicySubstatus {
  return (POLICY_SUBSTATUSES as readonly unknown[]).includes(value);
}

const POLICY_SUBSTATUS_LABELS: Record<PolicySubstatus, string> = {
  "non-renewal": "Non-renewal",
};

export function formatPolicySubstatusLabel(substatus: PolicySubstatus): string {
  return POLICY_SUBSTATUS_LABELS[substatus];
}
